import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ItemsMenuEl } from "common/components/items-menu";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { SkeletonListEl } from "common/components/skeleton-list";
import { SkeletonListRowSize } from "common/components/skeleton-list/types";
import { ItemsMenuSize } from "common/components/items-menu/types";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { Placement } from "common/components/tooltip/types";
import { TagInputEl } from "common/components/tag-input";
import { TagInputSearchMode } from "common/components/tag-input/types";
import { isEventItem } from "common/query-builder/query-block/events-menu/util";
import { Direction } from "common/components/resizable-panel/types";
import { ResizablePanelEl } from "common/components/resizable-panel";
import { MenuSearchBar } from "../mixins/search";
import { SortBy } from "../properties-menu/types";
import { FilterDropdownWrapperEl } from "../filter-dropdown-wrapper";
import { createContextPanelEventHandlers } from "./context-panel";
function EventItemsMenu() {
  let keydownProxyEl = null;
  if (this.canUseImprovedQbMenus()) {
    if (!this.state.isSearchTagsMenuOpen) {
      keydownProxyEl = this.state.searchInputEl;
    }
  } else if (!this.state.isModalOpen) {
    keydownProxyEl = document.body;
  } else {
    keydownProxyEl = this.state.keydownProxyEl;
  }
  return this.helpers.isLoading() ? /* @__PURE__ */ jsx(SkeletonListEl, {
    attrs: { "num-rows": 10, "row-size": SkeletonListRowSize.Large },
    sel: ".mp-events-menu-skeleton-list"
  }) : /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".mp-events-menu-items-menu",
    attrs: {
      elref: `mainSelectionMenu`,
      "empty-message": `No items found`,
      multiple: this.attr(`multiple`),
      "search-filter": this.state.searchFilter,
      "disable-search-sort": true,
      "disable-first-item-padding": true
    },
    on: {
      click: (ev) => ev.stopPropagation(),
      clickItem: (ev) => this.handleClickItem(ev),
      ...!this.canUseImprovedQbMenus() && { clickExpanderItem: (ev) => this.handleExpandItemClick(ev) },
      ...createContextPanelEventHandlers({
        track: this.trackEvent.bind(this),
        handleSelect: ({ item }) => this.triggerModal(item.value.modalType),
        handleDelete: ({ id }) => this.handleCustomEventDelete(id),
        additionalArgs: {
          "all-data-groups": this.attr(`all-data-groups`),
          "project-has-people": this.attr(`project-has-people`),
          "track-name": this.attr(`track-name`)
        }
      })
    },
    props: {
      sections: this.helpers.getMenuSections(),
      keydownProxyEl,
      sectionsFromInputFn: this.helpers.sectionsFromInput,
      customSearchMatcherFn: this.helpers.customSearchMatcherFn,
      contextPanelTransform: (sectionItem) => {
        const eventMenuItem = sectionItem.value;
        if (!eventMenuItem || !isEventItem(eventMenuItem)) {
          return null;
        }
        if (eventMenuItem && !eventMenuItem.icon) {
          eventMenuItem.icon = sectionItem.icon;
        }
        if (sectionItem.itemFromInput) {
          eventMenuItem.itemFromInput = sectionItem.itemFromInput;
        }
        return this.getTooltipData(eventMenuItem);
      },
      contextPanelPositionParentElement: this.helpers.getChildMenuRef()
    }
  });
}
function ImprovedEventsMenuInner() {
  if (!this.attr(`open`)) {
    return null;
  }
  const SearchInput = () => {
    return /* @__PURE__ */ jsx("div", {
      sel: ".search-wrapper"
    }, /* @__PURE__ */ jsx(TagInputEl, {
      sel: ".search-input",
      attrs: {
        tags: this.getSearchSelectedTagItems(),
        placeholder: `Search Events, use # to filter to tags`,
        "min-tags": 0,
        "show-search-icon": true,
        "show-clear": true,
        "search-mode": TagInputSearchMode.Hashtag,
        "mp-items-menu-attrs": {
          "empty-message": `No tags in use`,
          "empty-search-results-message": `No results found`
        }
      },
      on: {
        change: (ev) => this.handleSearchInputChange(ev),
        focus: () => this.handleSearchInputFocus(),
        blur: () => this.handleSearchInputBlur(),
        clear: () => this.handleSearchInputClear(),
        tagMenuChange: (ev) => this.handleSearchTagMenuChange(ev)
      },
      props: {
        value: this.state.searchFilter,
        tagMenuSections: this.getSearchTagMenuSections()
      },
      hook: {
        insert: (vnode) => this.handleSearchInputInsert(vnode)
      }
    }), this.helpers.canCreateItems() && /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".add-custom-event-button",
      attrs: {
        icon: `plus`,
        theme: ButtonTheme.Tertiary,
        size: ButtonSize.Medium,
        tooltip: { text: `Create Custom Event`, placement: Placement.Top }
      },
      on: {
        click: async () => this.helpers.triggerCreateCustomEventModal()
      }
    }));
  };
  const Sidebar = () => {
    return this.helpers.isLoading() ? /* @__PURE__ */ jsx(SkeletonListEl, {
      sel: ".sidebar.sidebar-skeleton-list",
      attrs: { "num-rows": 10, "row-size": SkeletonListRowSize.Large }
    }) : /* @__PURE__ */ jsx(ItemsMenuEl, {
      sel: ".sidebar",
      attrs: {
        tabindex: 0,
        size: ItemsMenuSize.Small,
        "disable-first-item-padding": true
      },
      props: {
        sections: this.getSidebarSections()
      },
      on: {
        clickItem: (ev) => this.handleClickSidebarItem(ev),
        clickExpansionToggleItem: (ev) => this.handleClickSidebarExpansionToggleItem(ev)
      }
    });
  };
  return /* @__PURE__ */ jsx(null, null, SearchInput(), /* @__PURE__ */ jsx("div", {
    sel: ".improved-menu-body"
  }, /* @__PURE__ */ jsx(ResizablePanelEl, {
    sel: ".sidebar-panel",
    attrs: {
      "storage-key": `events-menu-sidebar`,
      "default-size": 130,
      "min-size": 130,
      "max-size": 300,
      "disable-collapsing": true,
      "panel-name": `Events Menu Sidebar`,
      "resize-direction": Direction.Right
    },
    props: { containerEl: this.parentElement }
  }, Sidebar()), EventItemsMenu.call(this)));
}
function ImprovedEventsMenu() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-events-menu",
    class: { "improved-menu": true, "mp-child-menu": true },
    hook: { insert: (vnode) => this.helpers.setChildMenuRef(vnode) }
  }, ImprovedEventsMenuInner.call(this));
}
export function template() {
  if (this.canUseImprovedQbMenus()) {
    return ImprovedEventsMenu.call(this);
  }
  if (!this.attr(`open`)) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".mp-events-menu",
      class: { "beta-menu": false, "mp-child-menu": true },
      hook: { insert: (vnode) => this.helpers.setChildMenuRef(vnode) }
    });
  }
  const FilterSelectEl = () => {
    return /* @__PURE__ */ jsx(FilterDropdownWrapperEl, {
      attrs: {
        "always-show-caret": true,
        theme: SelectTheme.MenuFilter,
        size: ButtonSize.Inline,
        sections: this.getTagFilterMenuItems(),
        "menu-width": null,
        "disable-search": true,
        "empty-label": `all events`
      },
      props: {
        handleFilterChange: this.helpers.handleTagFilterChange
      }
    });
  };
  const CreateItemsMenuEl = () => {
    return /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".create-custom-button",
      attrs: {
        disabled: !this.helpers.canCreateItems(),
        "show-preview-tooltip": false,
        theme: ButtonTheme.MenuFooter,
        "hide-input-focus-styling": true,
        label: `Create Custom`
      },
      on: {
        click: async () => this.helpers.triggerCreateCustomEventModal()
      }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".create-custom-label",
      attrs: { elref: `label` }
    }, "Create Custom"));
  };
  const InnerSearch = MenuSearchBar({
    value: this.state.searchFilter,
    handleSearchInput: this.helpers.handleSearchInput,
    placeholder: this.helpers.getSearchPlaceholder(),
    onInsert: (el) => this.update({ keydownProxyEl: el }),
    key: `context`
  });
  const isLoading = this.helpers.isLoading();
  const hasSortFilterRow = this.canSortItems();
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-events-menu",
    class: { "beta-menu": false, "mp-child-menu": true },
    hook: { insert: (vnode) => this.helpers.setChildMenuRef(vnode) }
  }, InnerSearch, hasSortFilterRow && /* @__PURE__ */ jsx("div", {
    sel: ".header-filter-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".showing-text-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".showing-text"
  }, this.state.searchFilter ? `Searching` : `Show`), /* @__PURE__ */ jsx(FilterSelectEl, null)), /* @__PURE__ */ jsx("div", {
    sel: ".header-extra-controls"
  }, this.helpers.shouldShowRefreshButton() && /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      icon: `refresh`,
      disabled: isLoading,
      theme: ButtonTheme.Tertiary,
      tooltip: { text: `Refresh events`, placement: Placement.Left }
    },
    on: {
      click: this.helpers.handleRefreshButtonClick
    }
  }), /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      "always-show-caret": true,
      "icon-only": true,
      icon: {
        leftIcon: (() => {
          switch (this.state.sortByValue) {
            case SortBy.NameAsc:
              return `sort-alpha-asc`;
            case SortBy.NameDesc:
              return `sort-alpha-desc`;
            default:
              return `relevancy`;
          }
        })()
      },
      theme: SelectTheme.Tertiary,
      size: ButtonSize.Medium,
      sections: [{ label: `Sort by`, items: this.helpers.getSortingOptionSectionItems() }],
      "menu-width": null,
      tooltip: { placement: Placement.Left }
    },
    on: {
      change: this.helpers.handleSortChange
    }
  }))), EventItemsMenu.call(this), /* @__PURE__ */ jsx(CreateItemsMenuEl, null));
}
